<template>
  <div class="main-container">
    <tl-header type="h1" class="label input-label margin-t-m">IT declarations</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <section>
      <div class="row">
        <div class="col-4">
          <div class="employee-card">
            <div>
              <img src="@/assets/user.svg" alt="actionIcon" />
            </div>
            <div class="card-details">
              <h4>Roxie Schmidt</h4>
              <p class="code">RC1234</p>
              <p>Effective from Aug 2019</p>
              <hr />
              <div class="row margin-t-s margin-b-s">
                <div class="col-6">Potential</div>
                <div class="col-6">Rs. 447503</div>
                <div class="col-6">Actual</div>
                <div class="col-6">Rs. 171042</div>
                <div class="col-6">Gap</div>
                <div class="col-6">Rs. 276460</div>
              </div>
              <hr />
              <p></p>
              <p>Taxable Income : Rs 712783</p>
              <p>Annual Tax: Rs 712783</p>
            </div>
          </div>
        </div>
      </div>

      <div class="margin-t-m">
        <tl-accordion :active="true">
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Salary &amp; Perks</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveSalary}">
                <div class="it_accordHeading d-heading" @click="isActiveSalary = !isActiveSalary">
                  <div class="row">
                    <div class="col-8">Salary</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="salaryList"
                          :showinrow="false"
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.record[slotprops.value.column.key]"
                              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                              <p v-else>-</p>
                            </div>
                          </template>
                        </data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveDeductions}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveDeductions = !isActiveDeductions"
                >
                  <div class="row">
                    <div class="col-8">Deductions</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="deductionsList"
                          :withForm="false"
                          :showinrow="false"
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.record[slotprops.value.column.key]"
                              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                              <p v-else>-</p>
                            </div>
                          </template>
                        </data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActivePerquisites}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActivePerquisites = !isActivePerquisites"
                >
                  <div class="row">
                    <div class="col-8">Perquisites</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="perksList"
                          :withForm="false"
                          :showinrow="false"
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.record[slotprops.value.column.key]"
                              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                              <p v-else>-</p>
                            </div>
                          </template>
                        </data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Exemption Under Section 10</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveHRA}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveHRA = !isActiveHRA"
                >House Rent Allowance</div>
                <div class="accordContent">
                  <div class="row margin-t-m" v-for="(house,index) in Exemption10.HRA" :key="index">
                    <div class="col-6">
                      <div class="d-heading2">House {{index+1}}</div>
                    </div>
                    <div class="col-6" v-if="Exemption10.HRA.length > 1">
                      <a class="delete-btn" @click="deleteHouse(index)">
                        <img src="@/assets/delete.svg" />
                        <span>Delete House</span>
                      </a>
                    </div>
                    <div class="col-12 margin-t-s">
                      <div class="icon">
                        <div class="d-heading2">Owner’s Details</div>
                        <div class="row">
                          <div class="col-4">
                            <txt
                              label="Name"
                              :name="'ownername'+index"
                              placeholder="Name"
                              v-model="house.ownerDetails.name"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="PAN number"
                              :name="'ownerpan'+index"
                              placeholder="BMQPR8328R"
                              v-model="house.ownerDetails.pan_number"
                            />
                          </div>
                          <div class="col-4">
                            <span class="input-label">PAN Card</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'file'+index">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'file'+index"
                                  @change="uploadPanCard($event.target.files[0], index, 'owner')"
                                />
                              </label>
                            </div>
                            <a
                              :href="house.ownerDetails.pancardUrl"
                              target="_blank"
                            >{{house.ownerDetails.fileName}}</a>
                          </div>
                          <div class="col-4">
                            <txt
                              label="Pincode"
                              :name="'ownerpincode'+index"
                              placeholder="pincode"
                              v-model="house.ownerDetails.pincode"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'owneraddress'+index"
                              placeholder="address"
                              v-model="house.ownerDetails.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              :name="'ownerstate'+index"
                              labelText="state_name"
                              :options="stateList"
                              v-model="house.ownerDetails.state"
                              @change="(val)=> house.ownerDetails.state = val"
                            ></tl-select>
                          </div>
                        </div>

                        <div class="row margin-t-m">
                          <div class="col-12 margin-b-m">
                            <tl-checkbox
                              label="Co- Owner details"
                              :name="'co_owner'+index"
                              v-model="house.ownerDetails.isCoOwner"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="Name"
                              :name="'coownername'+index"
                              placeholder="Name"
                              v-model="house.ownerDetails.cownerDetails.name"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="PAN number"
                              :name="'cownerpan'+index"
                              placeholder="BMQPR8328R"
                              v-model="house.ownerDetails.cownerDetails.pan_number"
                            />
                          </div>
                          <div class="col-4">
                            <span class="input-label">PAN Card</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'coownerfile'+index">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'coownerfile'+index"
                                  @change="uploadPanCard($event.target.files[0], index, 'co-owner')"
                                />
                              </label>
                            </div>
                            <a
                              :href="house.ownerDetails.cownerDetails.pancardUrl"
                              target="_blank"
                            >{{house.ownerDetails.cownerDetails.fileName}}</a>
                          </div>
                          <div class="col-4">
                            <txt
                              label="Pincode"
                              :name="'coownerpincode'+index"
                              placeholder="pincode"
                              v-model="house.ownerDetails.cownerDetails.pincode"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'coowneraddress'+index"
                              placeholder="address"
                              v-model="house.ownerDetails.cownerDetails.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              labelText="state_name"
                              :name="'coownerstate'+index"
                              :options="stateList"
                              v-model="house.ownerDetails.cownerDetails.state"
                              @change="(val) => house.ownerDetails.cownerDetails.state = val"
                            ></tl-select>
                          </div>
                        </div>
                        <div class="row margin-t-m" v-for="(item,idx) in house.rentList" :key="idx">
                          <div class="col-3">
                            <div class="label">
                              <span class="input-label">Rent from</span>
                              <date-picker
                                :value="item.rentFrom"
                                @datevalue="(val)=>item.rentFrom=val"
                                :name="'rentFrom'+index+idx"
                              />
                            </div>
                          </div>
                          <div class="col-2">
                            <div class="label">
                              <span class="input-label">Rent to</span>
                              <date-picker
                                :value="item.rentTo"
                                @datevalue="(val)=>item.rentTo=val"
                                :name="'rentTo'+index+idx"
                              />
                            </div>
                          </div>
                          <div class="col-2">
                            <txt
                              type="number"
                              label="Amount"
                              :name="'rentamount'+index+idx"
                              placeholder="amount"
                              v-model="item.amount"
                            />
                          </div>
                          <div class="col-3">
                            <span class="input-label">Rent Agreement</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'agreementfile'+index+idx">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'agreementfile'+index+idx"
                                  @change="uploadFile($event.target.files[0], index, idx)"
                                />
                              </label>
                            </div>
                            <a :href="item.agreementDoc" target="_blank">{{item.fileName}}</a>
                          </div>
                          <div class="col-2" v-if="house.rentList.length > 1">
                            <a class="delete-btn" @click="deleteDate(index, idx)">
                              <img src="@/assets/delete.svg" />
                              <span>Delete House</span>
                            </a>
                          </div>
                        </div>
                        <div class="row margin-t-m margin-b-l">
                          <div class="col-12">
                            <div class="row-container align-center">
                              <img src="@/assets/group-5.svg" class="Group-5" />
                              <button class="text-green" @click="addMoreDate(index)">Add New Date</button>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-t-m">
                          <div class="col-4">
                            <txt
                              label="Pin code"
                              :name="'pincode'+index"
                              placeholder="pincode"
                              v-model="house.pincode"
                            />
                          </div>
                          <div class="col-4">
                            <span class="inline-flex margin-t-m">
                              <tl-radio
                                label="Metro"
                                :id="'metro'+index"
                                value="metro"
                                :name="'cityType'+index"
                                v-model="house.cityType"
                              ></tl-radio>
                              <tl-radio
                                label="Non-Metro"
                                :id="'non_metro'+index"
                                value="non_metro"
                                :name="'cityType'+index"
                                v-model="house.cityType"
                              ></tl-radio>
                            </span>
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'address'+index"
                              placeholder="address"
                              v-model="house.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              labelText="state_name"
                              :name="'state'+index"
                              :options="stateList"
                              v-model="house.State"
                              @change="(val) => house.State = val"
                            ></tl-select>
                          </div>
                        </div>
                        <!-- <div class="row margin-t-l">
                          <div class="col-12">
                            <span>
                              <a href="javascript:void(0)" class="text-green">Generate</a> Self Declaration Form , Sign it and upload in the space below
                            </span>
                          </div>
                          <div class="col-12 margin-t-s">
                            <upload @change="getFile($event)" />
                          </div>
                        </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="row margin-t-m margin-b-l">
                    <div class="col-12">
                      <div class="row-container align-center">
                        <img src="@/assets/group-5.svg" class="Group-5" />
                        <button class="text-green" @click="addMoreHouse">Add More House</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- others -->

            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveOthers}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveOthers = !isActiveOthers"
                >Others</div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="exemptTableColumns"
                          :tableData="Exemption10.others"
                          :showinrow="false"
                          :withForm="false"
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.column.key == 'slno'"
                              >{{slotprops.value.index+1}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'name'"
                              >{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] : slotprops.value.record.InvestmentComponentType.name}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'limits'"
                              >{{slotprops.value.record['rule']?slotprops.value.record['rule'].maximum_limit: slotprops.value.record.InvestmentComponentType.maximumAmount}}</p>
                              <p v-if="slotprops.value.column.key=='planned'">
                                <txt
                                  type="number"
                                  :name="'explannedvalue'+slotprops.value.index"
                                  v-model="Exemption10.others[slotprops.value.index].planned"
                                />
                                <!-- <span v-else>-</span> -->
                              </p>
                            </div>
                          </template>
                        </data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Previous Employment Details</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <ul class="table-header header-table">
              <li class="table-header-item">Particulars</li>
              <li class="table-header-item">Amount</li>
            </ul>
            <div class="row-div">
              <ul class="table-row">
                <li class="table-row-item">Salary Income After Section 10</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    name="salary_income"
                    v-model="previousEmploymentDetails.salary_income.amount"
                  />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PT Amount</li>
                <li class="table-row-item">
                  <txt type="number" name="pt" v-model="previousEmploymentDetails.pt.amount" />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">VPF</li>
                <li class="table-row-item">
                  <txt type="number" name="vpf" v-model="previousEmploymentDetails.vpf.amount" />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PF</li>
                <li class="table-row-item">
                  <txt type="number" name="pf" v-model="previousEmploymentDetails.pf.amount" />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">NPS</li>
                <li class="table-row-item">
                  <txt type="number" name="nps" v-model="previousEmploymentDetails.nps.amount" />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">Income Tax Deduction</li>
                <li class="table-row-item">
                  <txt type="number" name="tds" v-model="previousEmploymentDetails.tds.amount" />
                </li>
              </ul>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Deductions Under Section -16</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <ul class="table-header header-table">
              <li class="table-header-item">Particulars</li>
              <li class="table-header-item">Amount</li>
            </ul>
            <div class="row-div">
              <ul class="table-row">
                <li class="table-row-item">Standard Deductions</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    :disabled="true"
                    name="st"
                    v-model="deductionsUnderSection16.sd"
                  />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PT Amount</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    :disabled="true"
                    name="pt"
                    v-model="deductionsUnderSection16.pt"
                  />
                </li>
              </ul>
            </div>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Section 24 (Housing Loan)</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="datatable-outer-container">
              <table class="datatable">
                <thead>
                  <tr class="header-row">
                    <th>Interest on housing loan (Self occupied)</th>
                    <th>Planned</th>
                  </tr>
                </thead>
                <tr
                  v-for="(item, index) in section24.self_occupied.selfOccupied"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'soamount'+index"
                      v-model="item.planned"
                      @change="sumSelfOccupied()"
                    />
                  </td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_planned"
                      :disabled="true"
                      v-model="section24.self_occupied.total_planned"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="d-payroll__accord margin-t-m">
              <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveHLOthers = !isActiveHLOthers"
                >Self - Decaration for Joint Property</div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <div class="row">
                          <div class="col-4">
                            <txt
                              type="text"
                              label="Name of Joint Holder"
                              name="joint_holder_name"
                              v-model="section24.self_occupied.joint_holder_name"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              type="text"
                              label="Relationship"
                              name="relationship"
                              v-model="section24.self_occupied.relationship"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                          <div class="col-4">
                            <txt
                              type="number"
                              name="tax_benefit"
                              v-model="section24.self_occupied.tax_benefit"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(letout, index) in section24.let_out_property" :key="index">
              <div class="row">
                <div class="col-12 align-right" v-if="section24.let_out_property.length > 1">
                  <a class="delete-btn" @click="deleteLetOut(index)">
                    <img src="@/assets/delete.svg" />
                    <span>Delete LetOut Property</span>
                  </a>
                </div>
              </div>
              <div class="datatable-outer-container">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>Income/loss from house property (Letout)</th>
                      <th>Planned</th>
                    </tr>
                  </thead>
                  <tr v-for="(item, idx) in letout.letOut" :key="idx" class="record-row">
                    <td>{{item.name}}</td>
                    <td>
                      <txt
                        type="number"
                        v-if="!item.isCalculate"
                        :name="'loplanned'+idx"
                        v-model="item.planned"
                        :disabled="item.isDisabled"
                      />
                      <txt
                        type="number"
                        v-else
                        :name="'loplanned'+idx"
                        v-model="item.planned"
                        @change="calculateOther(index, idx, item.name)"
                        :disabled="item.isDisabled"
                      />
                    </td>
                  </tr>
                  <!-- <tr class="record-row">
                    <td>
                      <b>Total</b>
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'totalletoutPlanned'+index"
                        :disabled="true"
                        v-model="letout.total_planned"
                      />
                    </td>
                  </tr>-->
                </table>
              </div>
              <div class="d-payroll__accord margin-t-m">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHLOthers = !isActiveHLOthers"
                  >Self - Decaration for Joint Property</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="col-12">
                        <div class="icon">
                          <div class="row">
                            <div class="col-4">
                              <txt
                                type="text"
                                label="Name of Joint Holder"
                                :name="'letout_joint_holder_name'+index"
                                v-model="letout.joint_holder_name"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                type="text"
                                label="Relationship"
                                :name="'letout_relationship'+index"
                                v-model="letout.relationship"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                            <div class="col-4">
                              <txt
                                type="number"
                                :name="'tax_benefit'+index"
                                v-model="letout.tax_benefit"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div class="row-container align-center">
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button class="text-green" @click="addMoreLetOut()">Add More Housing Properties</button>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>
        <tl-accordion :disabled="!isOtherIncomeAllowed">
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Other Income</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <data-table
              :columns="otherIncTableColumns"
              :tableData="otherIncomeList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p v-if="slotprops.value.column.key == 'slno'">{{slotprops.value.index+1}}</p>
                  <p v-if="slotprops.value.column.key == 'name'">{{slotprops.value.record['name']}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].planned"
                    />
                  </p>
                </div>
              </template>
            </data-table>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Deduction Under Chapter VI A</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="group-heading">80C</div>
            <data-table
              :columns="chapterTableColumns"
              :tableData="chapterDataList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p
                    v-if="slotprops.value.column.key == 'display_group'"
                  >{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] : slotprops.value.record.InvestmentComponentType.abbreviation}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'name'"
                  >{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] : slotprops.value.record.InvestmentComponentType.name}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'maxLimit'"
                  >{{slotprops.value.record['rule'] ? slotprops.value.record['rule'].maximum_limit:slotprops.value.record.InvestmentComponentType.maximumAmount}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :name="'dvalue'+slotprops.value.index"
                      v-model="chapterDataList[slotprops.value.index].planned"
                    />
                  </p>
                </div>
              </template>
            </data-table>
            <div class="group-heading margin-t-m">Others</div>
            <data-table
              :columns="chapterTableColumns"
              :tableData="chapterOtherDataList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p
                    v-if="slotprops.value.column.key == 'display_group'"
                  >{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] : slotprops.value.record.InvestmentComponentType.abbreviation}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'name'"
                  >{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] : slotprops.value.record.InvestmentComponentType.name}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'maxLimit'"
                  >{{slotprops.value.record['rule'] ? slotprops.value.record['rule'].maximum_limit: slotprops.value.record.InvestmentComponentType.maximumAmount}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :name="'ovalue'+slotprops.value.index"
                      v-model="chapterOtherDataList[slotprops.value.index].planned"
                    />
                  </p>
                </div>
              </template>
            </data-table>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Taxable Income and TDS Breakup</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.amount}}</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="group-heading row">
              <div class="col-6">i) Taxable Income</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.taxable_income}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">ii) Taxable Income round off to nearest 10 rupees</div>
              <div
                class="col-6 align-right"
              >Rs. {{tds_breakup_and_taxable_income.taxable_income_roundoff}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">iii) Total Tax To be Paid</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.total_tax_paid}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.totalTax"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'tdsamount'+index"
                      v-model="item.amount"
                      @change="sumTotalTax()"
                    />
                  </td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_tdsamount"
                      :disabled="true"
                      v-model="tds_breakup_and_taxable_income.total_tdsamount"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="group-heading row">
              <div class="col-6">iv) Paid till Date</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.paid_till_date}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <thead>
                  <tr class="header-row">
                    <th></th>
                    <th>Tax</th>
                    <th>Surcharge</th>
                    <th>Edu. Cess</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.tdsPaid"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt type="number" :name="'tax'+index" v-model="item.tax" @change="sumTax()" />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'surcharge'+index"
                      v-model="item.surcharge"
                      @change="sumSurcharge()"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'educess'+index"
                      v-model="item.edu_cess"
                      @change="sumEduCess()"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'total'+index"
                      v-model="item.total"
                      @change="sumTotal()"
                    />
                  </td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_tax"
                      :disabled="true"
                      v-model="tds_breakup_and_taxable_income.total_tax"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_surcharge"
                      :disabled="true"
                      v-model="tds_breakup_and_taxable_income.total_surcharge"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_educess"
                      :disabled="true"
                      v-model="tds_breakup_and_taxable_income.total_edu_cess"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_total"
                      :disabled="true"
                      v-model="tds_breakup_and_taxable_income.total_total"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="group-heading row">
              <div class="col-6">v) Balance Tax Payable/Refund</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.balance_tax}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">vi) Balance Payable ( in 1 installments ) - Income Tax</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.balance_tax_one}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">vii) Current Month Tax Deduction</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.curren_month_tax}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.currentMonthTax"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt type="number" :name="'tdsamount'+index" v-model="item.amount" />
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </tl-accordion>
      </div>
    </section>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <div class="row">
            <div class="col-8">
              <h3>Dependent Details</h3>
            </div>
            <div class="col-4">
              <a href="javascript:void(0)" @click="okbtn" class="close-btn">close</a>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <txt label="Name" name="name" placeholder="name" />
            </div>
            <div class="col-6">
              <div class="label">
                <span class="input-label">Date of birth</span>
                <date-picker @datevalue="(val)=>dependentDetails.dob=val" name="dob" />
              </div>
            </div>
            <div class="col-6 margin-t-m">
              <tl-select name="relation" label="Relationship" :options="relationList"></tl-select>
            </div>
          </div>
          <div class="row margin-t-l">
            <div class="col-6">
              <div class="row-container align-center">
                <img src="@/assets/group-5.svg" class="Group-5" />
                <button class="text-green">Save and Add More</button>
              </div>
            </div>
            <div class="col-6">
              <btn text="Save" type="primary"></btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submitData" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  get_axios_file_instance,
  api_variables,
  errorHandler
} from "@/apis/variables.js";
import { commonData } from "../../../../../../../apis/constants.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  data() {
    return {
      accordionIndex: 0,
      employeeData: {},
      showModal: false,
      isActiveSalary: true,
      isActiveDeductions: true,
      isActivePerquisites: true,
      isActiveHRA: true,
      isActiveOthers: true,
      isActiveHLOthers: true,
      showDocModal: false,
      toast: false,
      errmsg: "",
      docsList: [],
      stateList: [],
      Exemption10: {
        HRA: [
          {
            address: "",
            pincode: "",
            State: "",
            cityType: "metro",
            rentList: [
              {
                rentFrom: "",
                rentTo: "",
                amount: "",
                agreementDoc: "",
                fileName: ""
              }
            ],
            ownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: "",
              fileName: "",
              isCoOwner: false,
              cownerDetails: {
                name: "",
                pan_number: "",
                pincode: "",
                address: "",
                state: "",
                pancardUrl: "",
                fileName: ""
              }
            }
          }
        ],
        others: []
      },
      section24: {
        let_out_property: [
          {
            letOut: [],
            total_planned: 0,
            total_actual: 0,
            total_approved: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
          }
        ],
        self_occupied: {
          selfOccupied: [],
          total_planned: 0,
          total_actual: 0,
          total_approved: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        }
      },
      exemptTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "name"
        },
        {
          label: "Yearly limits",
          key: "limits"
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
      previousEmploymentDetails: {
        salary_income: { amount: 0, location: [] },
        pt: { amount: 0, location: [] },
        vpf: { amount: 0, location: [] },
        pf: { amount: 0, location: [] },
        nps: { amount: 0, location: [] },
        tds: { amount: 0, location: [] }
      },
      deductionsUnderSection16: {
        sd: 0,
        pt: 0
      },
      chapterTableColumns: [
        {
          label: "Group",
          key: "display_group"
        },
        {
          label: "Description",
          key: "name"
        },
        {
          label: "Max. Limit",
          key: "maxLimit"
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
      chapterDataList: [],
      chapterOtherDataList: [],
      preEmpDetailsTableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Amount",
          key: "amount"
        }
      ],
      preEmpDetails: [
        {
          particulars: "Salary Income After Section 10",
          amount: "120000"
        },
        {
          particulars: "PT Amount",
          amount: "120000"
        }
      ],
      otherIncTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "name"
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
      otherIncomeList: [
        {
          name: "Interest From saving Accounts",
          value: 0,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Interest From Fixed Deposits",
          value: 0,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Any other Income",
          value: 0,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        }
      ],
      salaryTableColumns: [],
      deductionsList: [],
      perksList: [],
      salaryList: [],
      relationList: commonData.relationshipList,
      rentFrom: "",
      rentTo: "",
      docUrl: "",
      index: 0,
      TDSTableColumns: [
        {
          label: "",
          key: "heading"
        },
        {
          label: "Tax",
          key: "tax"
        },
        {
          label: "Surcharge",
          key: "surcharge"
        },
        {
          label: "Edu. Cess",
          key: "edu_cess"
        },
        {
          label: "Total",
          key: "total"
        }
      ],

      tds_breakup_and_taxable_income: {
        amount: 0,
        total_tdsamount: 0,
        total_tax: 0,
        total_surcharge: 0,
        total_edu_cess: 0,
        total_total: 0,
        taxable_income: 0,
        taxable_income_roundoff: 0,
        balance_tax: 0,
        balance_tax_one: 0,
        curren_month_tax: 0,
        paid_till_date: 0,
        total_tax_paid: 0,
        totalTax: [
          {
            name: "Actual Tax",
            amount: 0
          },
          {
            name: "Tax Rebate",
            amount: 0
          },
          {
            name: "Tax",
            amount: 0
          },
          {
            name: "Surcharge ",
            amount: 0
          },
          {
            name: "Edu. Cess",
            amount: 0
          }
        ],
        tdsPaid: [
          {
            name: "Deduction Through",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Payroll",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Direct TDS",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Pervious Employment",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          }
        ],
        currentMonthTax: [
          {
            name: " Regular Tax",
            amount: 0
          },
          {
            name: "One Time Tax",
            amount: 0
          },
          {
            name: "Total for the month",
            amount: 0
          }
        ]
      },
      isOtherIncomeAllowed: false
    };
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ...mapState({
      incomeTaxData: state => state.onboard.statutoryinfo.incometax.data,
      globalData: state => state.globalapi.globalData.data
    })
  },
  activated() {
    if (this.incomeTaxData[this.le_id]) {
      let obj = this.incomeTaxData[this.le_id].itSettings;
      if (obj.declareOtherIncome) {
        this.isOtherIncomeAllowed = true;
      } else {
        this.isOtherIncomeAllowed = false;
      }
    }
    this.calculateSalaryColumns();
    this.calculatFY();
    this.calculateLetOutFy();
    this.setGolbalData();
    this.getITDeclarationsData();
  },
  methods: {
    ...mapActions({
      act_fetchITDeclarationData:
        "dashboard/organisation/utilities/itdeclarations/fetchITDeclaration",
      act_submitITDeclarationData:
        "dashboard/organisation/utilities/itdeclarations/create"
    }),
    setGolbalData() {
      try {
        this.stateList = this.globalData
          ? this.globalData.State
            ? this.globalData.State
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    calculateSalaryColumns() {
      try {
        let d = new Date();
        let year = d.getFullYear();
        let next_year = (year + 1).toString().slice(2, 4);
        let last_two_digits = year.toString().slice(2, 4);
        this.salaryTableColumns = [
          {
            label: "Particulars",
            key: "name"
          },
          {
            label: "Apr",
            key: "April"
          },
          {
            label: "May",
            key: "May"
          },
          {
            label: "Jun",
            key: "June"
          },
          {
            label: "Jul",
            key: "July"
          },

          {
            label: "Aug",
            key: "August"
          },
          {
            label: "Sep",
            key: "September"
          },
          {
            label: "Oct",
            key: "October"
          },
          {
            label: "Nov",
            key: "November"
          },
          {
            label: "Dec",
            key: "December"
          },
          {
            label: "Jan",
            key: "January"
          },
          {
            label: "Feb",
            key: "February"
          },
          {
            label: "Mar",
            key: "mar"
          }
        ];
        this.salaryTableColumns.forEach((element, index) => {
          if (index) {
            if (index < 10) {
              element.label = element.label + "'" + last_two_digits;
            } else {
              element.label = element.label + "'" + next_year;
            }
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculatFY() {
      try {
        let d = new Date();
        let year = d.getFullYear();
        this.section24.self_occupied.selfOccupied = [
          {
            name: "Current Year Interest",
            planned: 0,
            actual: 0,
           // approved: 0
          }
        ];
        for (let i = 1; i <= 5; i++) {
          let next_year = year - i;
          this.section24.self_occupied.selfOccupied.push({
            name: "Pre EMI Interest " + (year - i + "-" + (next_year + 1)),
            planned: 0,
            actual: 0,
            //approved: 0
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateLetOutFy() {
      try {
        this.section24.let_out_property.forEach(element => {
          element.letOut = [
            {
              name: "Current Year Interest",
              planned: 0,
              actual: 0,
              approved: 0,
            }
          ];
          for (let i = 1; i <= 5; i++) {
            element.letOut.push({
              name: "Pre EMI Interest FY" + i,
              planned: 0,
              actual: 0,
              approved: 0,
            });
          }
          element.letOut.push(
            {
              name: "A Total rent received by employee",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "B Less: municipal Taxes Paid",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "C (A-B) Net Annual Value",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "D (C* 30%) Less: Standard Deduction @ 30%",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "E Less: Interest on Housing Loan",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "F (C-D-E) Income/Loss on House Property",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            }
          );
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateOther(letOutIndex, rowIndex, name) {
      try {
        let obj1 = {};
        let index = 0;
        let obj2 = {};
        if (name == "A Total rent received by employee") {
          index = rowIndex + 2;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex + 1
          ];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
        } else {
          index = rowIndex + 1;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex - 1
          ];
        }
        this.section24.let_out_property[letOutIndex].letOut[index].planned =
          obj1.planned - obj2.planned;
        this.section24.let_out_property[letOutIndex].letOut[index + 1].planned =
          (30 *
            this.section24.let_out_property[letOutIndex].letOut[index]
              .planned) /
          100;
        this.section24.let_out_property[letOutIndex].letOut[index + 3].planned =
          this.section24.let_out_property[letOutIndex].letOut[index].planned -
          this.section24.let_out_property[letOutIndex].letOut[index + 1]
            .planned -
          this.section24.let_out_property[letOutIndex].letOut[index + 2]
            .planned;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumSelfOccupied() {
      try {
        let sum = 0;
        this.section24.self_occupied.selfOccupied.forEach(element => {
          sum += element.planned;
        });
        this.section24.self_occupied.total_planned = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumTotalTax() {
      try {
        let sum = 0;
        this.tds_breakup_and_taxable_income.totalTax.forEach(element => {
          sum += element.amount;
        });
        this.tds_breakup_and_taxable_income.total_tdsamount = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumTax() {
      try {
        let sum = 0;
        this.tds_breakup_and_taxable_income.tdsPaid.forEach(element => {
          sum += element.tax;
        });
        this.tds_breakup_and_taxable_income.total_tax = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumSurcharge() {
      try {
        let sum = 0;
        this.tds_breakup_and_taxable_income.tdsPaid.forEach(element => {
          sum += element.surcharge;
        });
        this.tds_breakup_and_taxable_income.total_surcharge = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumEduCess() {
      try {
        let sum = 0;
        this.tds_breakup_and_taxable_income.tdsPaid.forEach(element => {
          sum += element.edu_cess;
        });
        this.tds_breakup_and_taxable_income.total_edu_cess = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumTotal() {
      try {
        let sum = 0;
        this.tds_breakup_and_taxable_income.tdsPaid.forEach(element => {
          sum += element.total;
        });
        this.tds_breakup_and_taxable_income.total_total = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async getITDeclarationsData() {
      try {
        let res = await this.act_fetchITDeclarationData({
          le_id: this.le_id,
          emp_id: this.$route.query.id,
          fy: 2019
        });
        if (res.data.status) {
          this.salaryList = [];
          this.deductionsList = [];
          this.perksList = [];
          let obj = res.data.payload;
          for (const key in obj.Salary.earnings) {
            if (obj.Salary.earnings.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.earnings[key]);
              this.salaryList.push({
                name: key,
                ...compObj
              });
            }
          }
          for (const key in obj.Salary.deductions) {
            if (obj.Salary.deductions.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.deductions[key]);
              this.deductionsList.push({
                name: key,
                ...compObj
              });
            }
          }
          for (const key in obj.Salary.perks) {
            if (obj.Salary.perks.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.perks[key]);
              this.perksList.push({
                name: key,
                ...compObj
              });
            }
          }
          this.chapterDataList = [];
          this.chapterOtherDataList = [];
          obj.deductionsUnderChapterVIA.forEach(element => {
            if (
              element.display_group == "80C" ||
              (element.InvestmentComponentType &&
                element.InvestmentComponentType.abbreviation == "80C")
            ) {
              this.chapterDataList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            } else {
              this.chapterOtherDataList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            }
          });
          this.Exemption10.others = [];
          obj.Exemption10.others.forEach(element => {
            this.Exemption10.others.push({
              planned: element.planned ? element.planned : 0,
              actual: element.actual ? element.actual : 0,
              ...element
            });
          });
          if (obj.Exemption10.HRA.length) {
            this.Exemption10.HRA = obj.Exemption10.HRA;
          }
          this.deductionsUnderSection16 = obj.deductionsUnderSection16;
          if (obj.otherIncome.length) {
            this.otherIncomeList = obj.otherIncome;
          }
          if (Object.keys(obj.previousEmploymentDetails).length) {
            this.previousEmploymentDetails = obj.previousEmploymentDetails;
          }
          if (Object.keys(obj.section24).length) {
            if (obj.section24.let_out_property.length) {
              this.section24.let_out_property = obj.section24.let_out_property;
            }
            this.section24.self_occupied = obj.section24.self_occupied;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async updateEmployeeItDeclaration() {
      try {
        let res = await this.act_updateEmplItDeclaration(this.employeeData);
      } catch (err) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/ITdeclarations`
      });
    },
    async uploadPanCard(docFile, index, type) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (type == "owner") {
                this.Exemption10.HRA[index].ownerDetails.pancardUrl =
                  res.data.location;
                this.Exemption10.HRA[index].ownerDetails.fileName =
                  docFile.name;
              } else {
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.pancardUrl = res.data.location;
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.fileName = docFile.name;
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadFile(docFile, index, idx) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              this.Exemption10.HRA[index].rentList[idx].agreementDoc =
                res.data.location;
              this.Exemption10.HRA[index].rentList[idx].fileName = docFile.name;
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async submitData() {
      try {
        this.section24.let_out_property.forEach(element => {
          let sum = 0;
          element.letOut.forEach(item => {
            sum += item.planned;
          });
          element.total_planned = sum;
        });
        let obj = {
          previousEmploymentDetails: this.previousEmploymentDetails,
          deductionsUnderSection16: this.deductionsUnderSection16,
          section24: this.section24,
          otherIncome: this.otherIncomeList,
          deductionsUnderChapterVIA: [
            ...this.chapterDataList,
            ...this.chapterOtherDataList
          ],
          exeption10: this.Exemption10,
          tds_breakup_and_taxable_income: this.tds_breakup_and_taxable_income,
          employee_id: this.$route.query.id,
          financial_year: "2019",
          le_id: this.le_id
        };

        let res = await this.act_submitITDeclarationData({ data: obj });
        if (res.data.status) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/importdeclarations`,
            query: { id: this.$route.query.id, status: "download" }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreLetOut() {
      try {
        this.section24.let_out_property.push({
          letOut: [],
          total_planned: 0,
          total_actual: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        });
        this.calculateLetOutFy();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteLetOut(index) {
      this.section24.let_out_property.splice(index, 1);
    },
    addMoreHouse() {
      try {
        this.Exemption10.HRA.push({
          address: "",
          pincode: "",
          State: "",
          cityType: "metro",
          rentList: [
            {
              rentFrom: "",
              rentTo: "",
              amount: "",
              agreementDoc: ""
            }
          ],
          ownerDetails: {
            name: "",
            pan_number: "",
            pincode: "",
            address: "",
            state: "",
            pancardUrl: "",
            isCoOwner: false,
            cownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: ""
            }
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteHouse(index) {
      try {
        this.Exemption10.HRA.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreDate(houseIndex) {
      try {
        this.Exemption10.HRA[houseIndex].rentList.push({
          rentFrom: "",
          rentTo: "",
          amount: "",
          agreementDoc: ""
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDate(houseIndex, dateIndex) {
      try {
        this.Exemption10.HRA[houseIndex].rentList.splice(dateIndex, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    okbtn() {
      this.showModal = false;
    },
    toggleContent(accordianType) {
      try {
        switch (accordianType) {
          case "employmentDetails":
            this.showEmploymentDetailsAccordionBody = !this
              .showEmploymentDetailsAccordionBody;
            break;
          case "sectionTen":
            this.showSectionTenAccordionBody = !this
              .showSectionTenAccordionBody;
            break;
          case "houseRent":
            this.showHouseRentAccordionBody = !this.showHouseRentAccordionBody;
            break;
          case "chapter6A":
            this.showChapter6AAccordionBody = !this.showChapter6AAccordionBody;
            break;

          default:
            this.showOtherIncomeAccordionBody = !this
              .showOtherIncomeAccordionBody;

            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-card {
  display: grid;
  grid-template-columns: 50px auto;

  grid-gap: 18px;
  max-width: 400px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  padding: 23px;
  img {
    width: 55px;
    height: 55px;
    opacity: 0.8;
    border-radius: 41px;
  }
  .card-details {
    .code {
      margin-bottom: 2px;
      color: #979797;
      font-size: 12px;
    }
    p {
      margin-bottom: 5px;
    }
    .year-data {
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      color: #535353;
    }
  }
}

.header-table {
  background-color: #f0f1f5;
}
.table-header {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;
  .table-header-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
  }
}
.row-div {
  &:nth-child(odd) {
    background-color: #f5f6fa;
  }
}
.table-row {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;

  .table-row-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
}
.close-btn {
  float: right;
  margin-top: 15px;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
}
.dependent-btn {
  float: right;
  color: #37c6c0;
  font-weight: 600;
  margin-top: 15px;
  font-size: 16px;
  text-decoration: none;
}
// accordian

.it_accordHeading {
  padding-left: 35px;
  padding-bottom: 5px;
  position: relative;
  cursor: pointer;
  border-bottom: 2px solid #e6e6e6;
  &:before {
    content: "\2010";
    position: absolute;
    color: #37c6c0;
    left: 10px;
    bottom: -10px;
    font-size: 40px;
  }
}
.it-payroll__accordBlock {
  .accordContent {
    display: none !important;
  }
  &.active {
    display: block;
    .accordContent {
      display: block !important;
    }
  }
}
.d-heading2 {
  font-size: 14px;
  color: #646464;
  font-weight: 600;
  border-bottom: none;
}
.attach_file {
  width: 35px;
  text-align: center;
  padding: 7px 14px;
  height: 35px;
  border-radius: 50%;
  background-color: #d8d8d8;
}
label.fileLabel input[type="file"] {
  opacity: 0;
  width: 0px;
  height: 0px;
  position: absolute;
  pointer-events: none;
}
label.fileLabel {
  color: #646464;
  text-decoration: underline;
  cursor: pointer;
  img {
    width: 10px;
  }
}
.inline-flex {
  display: inline-flex;
}
.group-heading {
  background-color: #d8d8d8;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-weight: 600;
}
.datatable-outer-container {
  width: 100%;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        padding: 0 8px;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}
.delete-btn {
  color: #37c6c0;
  font-weight: 600;
  margin-top: 15px;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  span {
    top: -3px;
    left: 10px;
    position: relative;
  }
}
</style>
